export default defineNuxtRouteMiddleware((to, from) => {
  if (to.meta.isLightbox || from.meta.isLightbox) {
    // Adding a transition wrapper here remounts the underlying page on first lightbox entry.
    to.meta.pageTransition = false;
  }
});
